import { createSlice } from '@reduxjs/toolkit';

export const huntgroupSlice = createSlice({
    name: 'huntgroup',
    initialState: {
        huntgroup_adduser_1: [],
        huntgroup_userList: [],
    },
    reducers: {
        sethuntgroup_adduser_1: (state, action) => {
            state.huntgroup_adduser_1 = action.payload;
        },
        sethuntgroup_userList: (state, action) => {
            state.huntgroup_userList = action.payload;
        }
    }
});

export const {
    sethuntgroup_adduser_1,
    sethuntgroup_userList
} = huntgroupSlice.actions

export default huntgroupSlice.reducer;